module.exports = __webpack_public_path__ + "our-tech-hero.jpg?b59dcc30909d482a3c21db38f2a50bb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-tech-hero.jpg
// module id = 241
// module chunks = 0